<!-- 验证邮箱组件 -->
<template id="id_validate">
  <section class="id-validate">
    <form class="s-form">
      <div class="s-form-row validated-info">
        <label class="s-form-label">
          已验证{{ v_type == 'email' ? '邮箱' : '手机' }}：
        </label>
        <div class="s-form-info">
          <span class="validated-item">{{ info }}</span>
          <a href="javascript:;" class="blue" @click="switchToPhoneValidate" v-if="switch_enabled">更换为{{ v_type != 'email' ? '邮箱' : '手机' }}验证</a>
        </div>
      </div>
      <send_code :type="v_type" :request="request" @errorResult="errorResult" :pwd_type="type" :modify_type="modify_type"></send_code>
      <div class="s-form-btnrow">
        <button type="button" class="s-button submit s-btn-warning" name="button" @click="next">{{ btn_text }}</button>
        <span class="button-tips">无法验证身份？进行 <a target="_blank" href="//wpa.b.qq.com/cgi/wpa.php?ln=1&key=XzgwMDgwMjAwMV80NDMwOTZfODAwODAyMDAxXzJf" class="blue">账户申诉</a></span>
      </div>
    </form>
    <v-alert :options="options"></v-alert>
  </section>
</template>

<script>
  import send_code from './send_code.vue'
  import vAlert from '../alert.vue'

  export default {
    props: ['v_type', 'switch_enabled', 'request', 'btn_text', 'type', 'modify_type'],
    computed: {
      info() {    //渲染的内容
        let type = this.v_type;

        return this.request[type];
      }
    },
    data() {
      return {
        options: {}
      }
    },
    methods: {
      /*
       ** 切换验证
       */
      switchToPhoneValidate() {
        let targetType = this.v_type == 'email' ? 'phone' : 'email';

        this.$emit('switchValidate', targetType);
      },
      /*
       ** 下一步
       */
      next() {
        let result = this.$children[0].validateCode();
        if(!result){
          let type = this.v_type,
              req = {};

          let url;

          switch(type) {
            case 'email':
              url = 'auth/email/check/';
              break;
            case 'phone':
            case 'pwd':
              url = 'auth/sms/check/';
              break;
          }
          //   验证码
          const smsCode = this.$children[0].code;
          req.code = smsCode

          //验证码是否正确
          axios.post(myUrl + url, qs.stringify(req)).then(response => {
            let res = response.data;

            if(res.result){
              const verificaPhone = {
                  precode: this.$children[0].code,
                  pretype: this.v_type
              }
              this.$store.commit('getVerificaPhone', verificaPhone)
              this.$emit('next', smsCode, res.code);
            }
            else{
              // console.log(res.message);
              this.options = {
                msgText: "验证码错误",
                msgIsSuccess: false
              }
            }
          }, reject => {
            console.log(reject);
          });
        }
      },
      errorResult(response) {
        this.$emit('errorResult', response);
      }
    },
    components: {
      send_code,
      vAlert
    }
  }
</script>

<style media="screen" scoped lang="scss">
  .s-form{
    .validated-item{
      margin-right: 40px;
      font-weight: bold;
    }
    .submit{
      width: 100px;
      margin-right: 15px;
    }

    .button-tips{
      font-size: 12px;
      color: #666;
    }
  }
</style>



// WEBPACK FOOTER //
// id_validate.vue?43add407